import React from "react";
import RichTextEditor from "react-rte";
export const HTMLEditor = ({ html, onChange, disabled, customControls, inputRef, hideEditor = false, }) => {
    const [editorValue, setEditorValue] = React.useState(RichTextEditor.createEmptyValue());
    React.useEffect(() => {
        if (html !== editorValue.toString("html")) {
            setEditorValue(editorValue.setContentFromString(html, "html"));
        }
    }, [html, editorValue]);
    const handleChange = React.useCallback((newValue) => {
        setEditorValue(newValue);
        onChange(newValue.toString("html"));
    }, [setEditorValue, onChange]);
    const toolbarConfig = {
        display: [
            "INLINE_STYLE_BUTTONS",
            "BLOCK_TYPE_BUTTONS",
            "LINK_BUTTONS",
            "BLOCK_TYPE_DROPDOWN",
            "HISTORY_BUTTONS",
        ],
        INLINE_STYLE_BUTTONS: [
            { label: "Bold", style: "BOLD" },
            { label: "Italic", style: "ITALIC" },
            { label: "Underline", style: "UNDERLINE" },
        ],
        BLOCK_TYPE_DROPDOWN: [
            { label: "Normal", style: "unstyled" },
            { label: "Heading Large", style: "header-one" },
            { label: "Heading Medium", style: "header-two" },
            { label: "Heading Small", style: "header-three" },
        ],
        BLOCK_TYPE_BUTTONS: [],
        BLOCK_ALIGNMENT_BUTTONS: [],
    };
    const disabledToolbarConfig = {
        extraProps: { isDisabled: true, disabled: true },
        ...toolbarConfig,
    };
    const hideEditorStyle = {
        borderBottom: "none",
        borderBottomLeftRadius: "0px",
        borderBottomRightRadius: "0px",
    };
    return (React.createElement(RichTextEditor, { value: editorValue, onChange: handleChange, ref: inputRef, toolbarConfig: hideEditor ? disabledToolbarConfig : toolbarConfig, readOnly: disabled, customControls: customControls, editorStyle: { display: hideEditor ? "none" : "block" }, rootStyle: hideEditor ? hideEditorStyle : {} }));
};
